import React from 'react';
import MoneyInput from '../money-input';
import CurrencySelect from '../currency-select';
import GLAccountSegmentConfiguration from './GLAccountSegmentConfiguration';

const ConfigurationSection = ({
    updatedClient,
    data,
    updateField,
    updateVariance,
    updateCostType,
    updateCostTypeNIN
}) => {
    return (
        <div className='mb-2'>
            <h5 className='mt-4'>
                {data.t.read("client_table.configuration")}
            </h5>
            <div className='row mt-1'>
                <div className='col-2'>Type :</div>
                <div className='col-10'>
                    <select required className='form-control'
                        value={updatedClient.config?.type || ""}
                        onChange={(e) => updateField("config", e.target.value, "type")}>
                        <option value="">--</option>
                        <option value="legal">Legal</option>
                        <option value="resto">Restaurant</option>
                    </select>
                </div>
            </div>
            <div className='row mt-1'>
                <div className='col-2'>{data.t.read("client_table.engine")}</div>
                <div className='col-10'>
                    <select required className='form-control'
                        value={updatedClient.config?.engine || ""}
                        onChange={(e) => updateField("config", e.target.value, "engine")}>
                        <option value="">--</option>
                        <option value="default">{data.t.read("client_table.default")}</option>
                        <option value="juris">Juris</option>
                        <option value="demo">Démo</option>
                    </select>
                </div>
            </div>
            <div className='row mt-1'>
                <div className='col-2'>
                    <label htmlFor='default-currency' className='mb-0'>
                        {data.t.read("client_table.default_currency")}
                    </label>
                </div>
                <div className='col-10'>
                    <CurrencySelect
                        inputId='default-currency'
                        value={updatedClient.config?.expenses?.default_currency}
                        onChange={(code) => updateField("config", code, "expenses", "default_currency")}
                        data={data}
                    />
                </div>
            </div>
            <div className='row mt-1'>
                <div className='col-2'>{data.t.read("language_preference")}:</div>
                <div className='col-10'>
                    <select required className='form-control'
                        value={updatedClient.config?.language_preference || ""}
                        onChange={(e) => updateField("config", e.target.value, "language_preference")}>
                        <option value="all">{data.t.read("all_languages")}</option>
                        <option value="english">{data.t.read("english")}</option>
                        <option value="french">{data.t.read("french")}</option>
                    </select>
                </div>
            </div>
            <div className='row mt-1'>
                <div className='col-2'>
                    {data.t.read("client_table.send_approval_request_email_for_each_request")}:
                </div>
                <div className='col-10'>
                    <label className='d-block pt-2 mb-0'>
                        <input
                            type="checkbox"
                            checked={updatedClient.config?.send_approval_request_email_for_each_request ?? false}
                            onChange={() =>
                                updateField(
                                    "config",
                                    !(updatedClient.config?.send_approval_request_email_for_each_request ?? false),
                                    "send_approval_request_email_for_each_request"
                                )
                            }
                        />{" "}
                        {data.t.read("client_table.send_approval_request_email_for_each_request_help")}
                    </label>
                </div>
            </div>
            <div className='row mt-1'>
                <div className='col-2'>
                    {data.t.read("client_table.allow_self_approval_assignment")}:
                </div>
                <div className='col-10'>
                    <label className='d-block pt-2 mb-0'>
                        <input
                            type="checkbox"
                            checked={updatedClient.config?.allow_self_approval_assignment ?? true}
                            onChange={() =>
                                updateField(
                                    "config",
                                    !(updatedClient.config?.allow_self_approval_assignment ?? true),
                                    "allow_self_approval_assignment"
                                )
                            }
                        />{" "}
                        {data.t.read("client_table.allow_self_approval_assignment_help")}
                    </label>
                </div>
            </div>
            {/* XPEN-3267 — rendered unconditionally, unlike the frontend_invoice
                block below: existing client documents carry no config.suppliers,
                and guarding on it would hide the switches on every client that
                has never been configured. Absent means allowed, on the server too. */}
            <div className='row mt-1'>
                <div className='col-2'>
                    {data.t.read("client_table.suppliers_governance")}:
                </div>
                <div className='col-10'>
                    <label className='d-block pt-2 mb-0'>
                        <input
                            type="checkbox"
                            checked={updatedClient.config?.suppliers?.allow_create !== false}
                            onChange={() =>
                                updateField(
                                    "config",
                                    updatedClient.config?.suppliers?.allow_create === false,
                                    "suppliers",
                                    "allow_create"
                                )
                            }
                        />{" "}
                        {data.t.read("client_table.allow_supplier_creation_help")}
                    </label>
                    <label className='d-block mb-0'>
                        <input
                            type="checkbox"
                            checked={updatedClient.config?.suppliers?.allow_import !== false}
                            onChange={() =>
                                updateField(
                                    "config",
                                    updatedClient.config?.suppliers?.allow_import === false,
                                    "suppliers",
                                    "allow_import"
                                )
                            }
                        />{" "}
                        {data.t.read("client_table.allow_supplier_import_help")}
                    </label>
                </div>
            </div>
            {updatedClient.config?.frontend_invoice && (
                <div className='row mt-1'>
                    <div className='col-2'>Frontend :</div>
                    <div className='col-10'>
                        <div className='row font-small'>
                            <div className='col-6'>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.frontend_invoice.hide_na_fields}
                                        onChange={() => updateField("config", !updatedClient.config.frontend_invoice.hide_na_fields, "frontend_invoice", "hide_na_fields")} /> {data.t.read("client_table.hide_empty_fields")}
                                </label>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.frontend_invoice.hide_cost_details_table}
                                        onChange={() => updateField("config", !updatedClient.config.frontend_invoice.hide_cost_details_table, "frontend_invoice", "hide_cost_details_table")} /> {data.t.read("client_table.hide_cost_details_table")}
                                </label>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.frontend_invoice.hide_work_date}
                                        onChange={() => updateField("config", !updatedClient.config.frontend_invoice.hide_work_date, "frontend_invoice", "hide_work_date")} /> {data.t.read("client_table.hide_work_date")}
                                </label>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.supplier_group ?? false}
                                        onChange={() => updateField("config", !updatedClient.config.supplier_group, "supplier_group")} /> {data.t.read("supplier_group")}
                                </label>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.frontend_invoice.hide_group_number ?? false}
                                        onChange={() => updateField("config", !updatedClient.config.frontend_invoice.hide_group_number, "frontend_invoice", "hide_group_number")} /> {`${data.t.read("client_table.hide")} '${data.t.read("invoice.group_number")}'`}
                                </label>
                            </div>
                            <div className='col-6'>
                                <label className='d-block'>
                                        <input type="checkbox"
                                            checked={updatedClient.config.frontend_invoice.hide_unit_in_gl_details_table}
                                            onChange={() => updateField("config", !updatedClient.config.frontend_invoice.hide_unit_in_gl_details_table, "frontend_invoice", "hide_unit_in_gl_details_table")} /> {data.t.read("client_table.hide_unit_from_gl_details")}
                                </label>

                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.frontend_invoice.hide_due_date}
                                        onChange={() => updateField("config", !updatedClient.config.frontend_invoice.hide_due_date, "frontend_invoice", "hide_due_date")} /> {data.t.read("client_table.hide_due_date")}
                                </label>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.frontend_invoice.approver_can_add_invoice ?? false}
                                        onChange={() => updateField("config", !updatedClient.config.frontend_invoice.approver_can_add_invoice, "frontend_invoice", "approver_can_add_invoice")} /> {data.t.read("client_table.approver_can_add_invoice")}
                                </label>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.frontend_invoice.TranDate ?? false}
                                        onChange={() => updateField("config", !updatedClient.config.frontend_invoice.TranDate, "frontend_invoice", "TranDate")} /> {`${data.t.read("show")} '${data.t.read("invoice.transaction_date")}'`}
                                </label>
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.auto_supplier_number ?? false}
                                        onChange={() => updateField("config", !updatedClient.config.auto_supplier_number, "auto_supplier_number")} /> {data.t.read("auto_supplier_number")}
                                </label>
                                {/* XPEN-3323: prefixes the ERP client's name onto the matter label in
                                    every matter picker. Lives in `config.matter_display` beside the
                                    XPEN-3094 identifier flags, which have no UI — `updateField`
                                    creates the container when the tenant has none. */}
                                <label className='d-block'>
                                    <input type="checkbox"
                                        checked={updatedClient.config.matter_display?.show_client_name ?? false}
                                        onChange={() => updateField("config", !updatedClient.config.matter_display?.show_client_name, "matter_display", "show_client_name")} /> {data.t.read("client_table.show_client_name_in_matter")}
                                </label>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <label htmlFor='cost-details-table-title'>
                                    {data.t.read("client_table.cost_details_table_title")}
                                </label>
                                <input
                                    id='cost-details-table-title'
                                    className='form-control'
                                    value={updatedClient.config.frontend_invoice.cost_details_table_title ?? ""}
                                    onChange={(e) => updateField("config", e.target.value, "frontend_invoice", "cost_details_table_title")}
                                    placeholder={data.t.read("invoice.cost_details")}
                                />
                            </div>
                            <div className='col-6'>
                                <label htmlFor='gl-details-table-title'>
                                    {data.t.read("client_table.gl_details_table_title")}
                                </label>
                                <input
                                    id='gl-details-table-title'
                                    className='form-control'
                                    value={updatedClient.config.frontend_invoice.gl_details_table_title ?? ""}
                                    onChange={(e) => updateField("config", e.target.value, "frontend_invoice", "gl_details_table_title")}
                                    placeholder={data.t.read("invoice.gl_details")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className='row mt-1'>
                <div className='col-2'>{data.t.read("fiscal_year")} :</div>
                <div className='ml-3'>
                    <select value={updatedClient.config?.fiscal_year_start || ""}
                        onChange={(e) => updateField("config", e.target.value, "fiscal_year_start")}
                        className='form-control'>
                        <option value=""
                            disabled>{data.t.read("start_fiscal_year")}</option>
                        <option value="01">{data.t.read("month.January")}</option>
                        <option value="02">{data.t.read("month.February")}</option>
                        <option value="03">{data.t.read("month.March")}</option>
                        <option value="04">{data.t.read("month.April")}</option>
                        <option value="05">{data.t.read("month.May")}</option>
                        <option value="06">{data.t.read("month.June")}</option>
                        <option value="07">{data.t.read("month.July")}</option>
                        <option value="08">{data.t.read("month.August")}</option>
                        <option value="09">{data.t.read("month.September")}</option>
                        <option value="10">{data.t.read("month.October")}</option>
                        <option value="11">{data.t.read("month.November")}</option>
                        <option value="12">{data.t.read("month.December")}</option>
                    </select>
                </div>
            </div>
            {updatedClient.config?.type === "legal" && <>
                <div className='row mt-1'>
                    <div className='col-2'>
                        {data.t.read("default_ap_gl_natural")} :
                    </div>
                    <div className='ml-3'>
                        <input className='form-control'
                            value={updatedClient.config?.ap_gl_natural || ""}
                            onChange={(e) => updateField("config", e.target.value, "ap_gl_natural")}
                            placeholder={data.t.read("default_ap_gl_natural")} />
                    </div>
                </div>
            
            <div className='row mt-1'>
                <div className='col-2'>
                    {data.t.read("default_cost_type")} :
                </div>
                <div className='ml-3'>
                    <input className='form-control'
                        value={updatedClient.config?.cost_type || ""}
                        onChange={(e) => updateCostType(e.target.value)}
                        placeholder={data.t.read("default_cost_type")} />
                </div>
            </div>
            <div className='row mt-1'>
                <div className='col-2'>
                    {data.t.read("default_cost_type_nin")} :
                </div>
                <div className='ml-3'>
                    <input className='form-control'
                        value={updatedClient.config?.cost_type_nin || ""}
                        onChange={(e) => updateCostTypeNIN(e.target.value)}
                        placeholder={data.t.read("default_cost_type_nin")} />
                </div>
            </div>
            </>}
            <div className='row mt-1'>
                <div className='col-2'>
                    {data.t.read("Variance")} :
                </div>
                <div className='ml-3'>
                    <MoneyInput value={updatedClient.config?.variance || ""}
                        onChange={(value) => updateVariance(value)}
                        locale={`${data.t.lang}-${data.t.lang.toUpperCase()}`}
                        placeholder="variance" />
                </div>
            </div>
            <GLAccountSegmentConfiguration 
                updatedClient={updatedClient}
                data={data}
                updateField={updateField}
            />
        </div>
    );
};

export default ConfigurationSection;
